import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
    color: COLOR_GRAY_70,
    textAlign: 'center',

    '& span': {
      fontWeight: 700,
      color: COLOR_PURPLE,
    },
  },
  switchBox: {
    borderRadius: 8,
    border: '1px solid #EAECF0',
    background: '#F9FAFB',
    padding: theme.spacing(0.75),
    margin: '0 auto',
    display: 'flex',
    maxWidth: 830,
    justifyContent: 'space-between',

    '& span': {
      fontWeight: 700,
      fontFamily: 'Lato',
    },
  },
  switch: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 6,
    padding: theme.spacing(1.25, 1.75),
    cursor: 'pointer',
    textTransform: 'initial',

    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
      background: '#fff',
    },
  },
  activeSwitch: {
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
    backgroundColor: '#FFF',
    color: COLOR_PURPLE,
  },
  contentTransition: {
    opacity: 1,
    visibility: 'visible',
    transition:
      'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, max-height 0.5s ease-in-out',
  },
  contentHidden: {
    opacity: 0,
    visibility: 'hidden',
    maxHeight: '0',
    overflow: 'hidden',
    transition:
      'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, max-height 0.5s ease-in-out',
  },
  titleSection: {
    fontSize: 30,
    fontWeight: 400,
    color: COLOR_GRAY_70,
    lineHeight: 1.1,

    '& span': {
      fontWeight: 700,
      color: COLOR_PURPLE,
    },
  },
  descriptionSection: {
    padding: theme.spacing(1, 0),
    color: COLOR_GRAY_70,

    '& span': {
      fontWeight: 700,
    },
  },
  price: {
    color: COLOR_GRAY_70,
    paddingLeft: theme.spacing(1),
    fontSize: 20,

    '& span': {
      fontSize: 40,
      fontWeight: 700,
    },
  },
}));
